import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InboxNavTicketRowContent({
  content,
  requestedBy
}) {
  if (!content && !requestedBy) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "50",
    children: [content && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-default",
      truncate: true,
      children: content
    }), requestedBy && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      truncate: true,
      children: requestedBy
    })]
  });
}